module.exports = {
    language: {
        name: 'English'
    },
    logo: {
        lastName: '赛德部落',
    },
    navBar: {
        home: '首页',
        serve: '产品服务',
        exhibition: '案例展示',
        contact: '关于我们'
    },
    productService: {
        app: '移动App定制',
        hardware: '硬件改造/建设',
        weiXin: '微信公众号/小程序开发',
        website: '网站/系统建设',
        operate: '线上推广',
        company: '政府/企业单位信息化建设'
    },
    serviceProcess: {
        our: '我们的',
        process: '服务流程',
        chart: [
            '沟通需求',
            '签订合同',
            'UI设计',
            '测试上线',
            '产品验收',
            '讨论方案',
            '原型设计',
            '产品研发',
            '支付使用',
        ]
    },
    exhibition:{
        more:'更多案例'
    },
    aboutUs: {
        introduce: '成都赛德部落科技有限公司成立于2015年，专注于提供行业解决方案、APP开发、 公众号/小程序开发、政企信息化系统等技术服务。'
    },
    footer:{
        phone:'联系电话',
        email:'联系邮箱',
        contact:'唐经理'
    }
}
